<template>
    <div class='tempDesignBanner' ref='divRef'>
        <span>We're rolling out a fresh new look and feel! You may notice some changes as we update our site.</span>
        <!-- <button > -->
            <img @click="$emit('tdbCloseFunc')" :src="closeIcon" width='24px' height='24px' />
        <!-- </button> -->
    </div>
</template>

<script>
    export default {
        props: ['tdbHeight'],
        emits: ['updateTdbHeight', 'tdbCloseFunc'],

        data () {
            return {
                closeIcon: require('../../static/img/close_icon.png')
            }
        },
        mounted () {
            // 2. Set initial height and add the resize listener
            this.updateHeight()
            window.addEventListener('resize', this.updateHeight)
        },
        beforeDestroy () {
            // 4. Remove listener to prevent memory leaks
            window.removeEventListener('resize', this.updateHeight)
            this.$emit('updateTdbHeight', 0)
        },
        methods: {
            updateHeight () {
            // 3. Get new height from the ref
                if (this.$refs.divRef) {
                    this.$emit('updateTdbHeight', this.$refs.divRef.clientHeight)
                }
            }
        }
    }
</script>

<style scoped>
    .tempDesignBanner {
        position: fixed;
        top: 0;
        z-index: 1010;
        width: 100vw;
        min-height: 56px;
        height: auto;
        padding: 24px 64px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(to right, #1957CD, #44CEA5)
    }

    span {
        font-family: "Mulish", serif;
        font-size: 20px;
        line-height: 30px;
        font-weight: 500;
        color: #fff;
    }

    img {
        margin-left: 24px;
        cursor: pointer;
    }

    @media (max-width: 991px) {
        .tempDesignBanner {
            min-height: 64px;
            padding: 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/TempDesignBanner.vue